import script from "./ProductFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&setup=true&lang=js"

import "./ProductFeatures.vue?vue&type=style&index=0&id=3e2fcf59&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2fcf59"]])

export default __exports__